



































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  PostGroupManagerPostGroupDTO,
  PostGroupMangerService,
} from "@/common/api/index";
import { namespace } from "vuex-class";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";

const auth = namespace("Auth");

@Component({
  name: "createPostGroup",
  components: {
    QErrors,
  },
})
export default class createPostGroup extends Vue {
  @auth.Getter
  getUsingGroup!: string;

  isShow = false;
  errors = {};

  names = [];

  numberpostGroupAdd: any = 0;

  deletedPostGroupIds: any = [];

  @Watch("postGroups")
  changePostGroups() {
    const postGroups = this.postGroups.filter((postGroup) => postGroup.id);
    this.numberpostGroupAdd = postGroups.length;
    console.log("postGroups", this.postGroups);
  }

  public postGroups: Array<PostGroupManagerPostGroupDTO> = [];

  async listPostGroup() {
    const response = await PostGroupMangerService.postGroup({
      groupId: Number.parseInt(this.getUsingGroup),
    });
    this.postGroups = response.data.post_groups;
  }

  async confirmDeletePostGroup(postGroupId, postGroupName, key, $event) {
    if (!postGroupId) {
      // Delete error
      delete this.errors[key];
      this.postGroups.splice(key, 1);
      return;
    }

    this.$modal.showDelete({
      text: this.$t("post_group.confirm_delete", { name: postGroupName }),
      onConfirm: () => {
        $event.target.closest("li").setAttribute("disabled", "disabled");
        this.deletedPostGroupIds.push(postGroupId);
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  addPostGroup() {
    this.postGroups.push({
      id: null,
      name: "",
    });
  }

  async submit() {
    this.errors = {};
    try {
      // console.log("Name:", this.names[key] || "");
      // Call API Create post group with list names
      const names: any = this.postGroups
        .filter((postGroup) => !postGroup.id)
        .map((postGroup) => postGroup.name);
      const response = await PostGroupMangerService.postGroupCreate({
        groupId: Number.parseInt(this.getUsingGroup),
        names: names,
        deletedPostGroupIds: this.deletedPostGroupIds,
      });

      // Show success message
      QNotify.success({
        text: response.message,
      });

      // Call emit to reload page
      this.$emit("reload");
      this.isShow = false;
    } catch (error) {
      console.log("errors:", this.errors);
      this.errors = error.body.errors;
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  close() {
    const postGroups = this.postGroups.filter((postGroup) => !postGroup.id);

    // Display popup warning if have additional postGroup
    if (postGroups.length > 0) {
      this.$modal.showCancel({
        text: this.$t("common.modal.cancel_content"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.isShow = false;
    }
  }

  async show() {
    await this.listPostGroup();
    this.deletedPostGroupIds = [];
    for (const element of this.$el.querySelectorAll(".post_group_name"))
      element.removeAttribute("disabled");
    this.errors = {};
    this.isShow = true;
  }
}
